import React, { useState } from 'react';
import axios from 'axios';

const ModalSetImg = ({
    el,
    changeImgUrl,
    isOverflowModal,
    isCarousel,
    callbackFromParent,
}) => {
    //state
    const [selectType, setSelectType] = useState('fileUpload');
    const [loading, setLoading] = useState(false);

    const loadingStyle = {
        backgroundColor: 'inherit',
        color: '#0f4b7f',
    };

    // form 기본 이벤트 막음
    const dialogForm = (e) => {
        e.preventDefault();
    };

    // select 변경
    const handleChangeSelect = (e) => {
        setSelectType(e.target.value);
    };

    // img url 변경
    const handleChangeUrl = (e) => {
        changeImgUrl(e.target.value);
    };

    // 이미지 업로드
    const handleChangeupload = (e) => {
        e.preventDefault();
        if (e.target.files[0].size < 3145728) {
            let formData = new FormData();
            formData.append('folderName', 'jsontobot');
            formData.append('file', e.target.files[0]);
            setLoading(true);
            axios
                .post('https://fileupload.cloudturing.com/upload', formData)
                .then((res) => {
                    setLoading(false);
                    if (res.data.result) {
                        let imgUrl = res.data.data[0].url;
                        changeImgUrl(imgUrl);
                    } else {
                        console.log('res.err', res.err);
                    }
                })
                .catch((err) => {
                    setLoading(false);
                    alert('파일 업로드에 실패했습니다. 다시 시도해주세요.');
                    console.log('Error', err);
                });
        } else {
            alert('이미지 최대 용량은 3MB 입니다.');
        }
    };

    // 이미지 링크 리스트
    let UpdatedImglinkList = {};
    // 이미지 링크 있으면 넣음
    if (el && el.thumbnail && el.thumbnail.link) {
        UpdatedImglinkList = el.thumbnail.link;
    }
    // 이미지 링크 입력
    const imgLinkList = (e) => {
        if (el && el.thumbnail && el.thumbnail.link) {
            UpdatedImglinkList = el.thumbnail.link;
        } else {
            el.thumbnail = {
                ...el.thumbnail,
                link: {},
            };
            UpdatedImglinkList = el.thumbnail.link;
        }

        let value = e.target.value;
        let label = e.target.name;
        if (value === '') {
            delete UpdatedImglinkList[label];
        } else {
            UpdatedImglinkList[label] = value;
        }
        callbackFromParent(UpdatedImglinkList);
    };

    return (
        <div className={`dialog-wrap img ${isOverflowModal ? 'left' : ''}`}>
            <h4>이미지 등록</h4>
            <button type="button">삭제</button>
            <form className="dialog-form" onSubmit={dialogForm}>
                {/* 이미지 업로드 */}
                <div>
                    <h5>
                        이미지 업로드 <span>*</span>
                        <em>(3MB 이하의 jpg, jpeg, png 이미지 파일)</em>
                    </h5>
                    <div className="dialog-form-img-upload">
                        <select onChange={handleChangeSelect}>
                            <option value="fileUpload">파일 업로드</option>
                            <option value="imgUrl">이미지 URL</option>
                        </select>
                        {selectType === 'imgUrl' ? (
                            <input
                                type="text"
                                placeholder="https://"
                                onChange={handleChangeUrl}
                            />
                        ) : (
                            <div className="dialog-form-img-file">
                                <label
                                    htmlFor="img-upload-btn"
                                    style={loading ? loadingStyle : {}}
                                >
                                    {!loading
                                        ? '여기를 클릭해서 파일을 선택'
                                        : '업로드중입니다.'}
                                </label>
                                <input
                                    type="file"
                                    id="img-upload-btn"
                                    name="file"
                                    onChange={handleChangeupload}
                                    accept=".jpeg, .jpg, .png"
                                />
                            </div>
                        )}
                    </div>
                </div>
                {isCarousel && (
                    <>
                        {/* 링크 설정 */}
                        <div>
                            <h5>링크 설정 (web link)</h5>
                            <input
                                type="text"
                                id="dg-img-web-link"
                                placeholder="https://"
                                className="width100"
                                name="web"
                                onChange={imgLinkList}
                                value={
                                    UpdatedImglinkList.web
                                        ? UpdatedImglinkList.web
                                        : ''
                                }
                            />
                        </div>
                        <hr />
                        <div>
                            {/* 링크 */}
                            <div>
                                <h5>
                                    링크 <i>(선택사항)</i>
                                </h5>
                                <ul className="dialog-form-link-list">
                                    <li>
                                        <label htmlFor="dg-img-link-mb">
                                            mobile link
                                        </label>
                                        <input
                                            type="text"
                                            id="dg-img-link-mb"
                                            placeholder="https://"
                                            name="mobile"
                                            onChange={imgLinkList}
                                            value={
                                                UpdatedImglinkList.mobile
                                                    ? UpdatedImglinkList.mobile
                                                    : ''
                                            }
                                        />
                                    </li>
                                    <li>
                                        <label htmlFor="dg-img-link-win">
                                            win link
                                        </label>
                                        <input
                                            type="text"
                                            id="dg-img-link-win"
                                            placeholder="https://"
                                            name="win"
                                            onChange={imgLinkList}
                                            value={
                                                UpdatedImglinkList.win
                                                    ? UpdatedImglinkList.win
                                                    : ''
                                            }
                                        />
                                    </li>
                                    <li>
                                        <label htmlFor="dg-img-link-mac">
                                            mac link
                                        </label>
                                        <input
                                            type="text"
                                            id="dg-img-link-mac"
                                            placeholder="https://"
                                            name="mac"
                                            onChange={imgLinkList}
                                            value={
                                                UpdatedImglinkList.mac
                                                    ? UpdatedImglinkList.mac
                                                    : ''
                                            }
                                        />
                                    </li>
                                    <li>
                                        <label htmlFor="dg-img-link-ios">
                                            iOS link
                                        </label>
                                        <input
                                            type="text"
                                            id="dg-img-link-ios"
                                            name="ios"
                                            onChange={imgLinkList}
                                            value={
                                                UpdatedImglinkList.ios
                                                    ? UpdatedImglinkList.ios
                                                    : ''
                                            }
                                        />
                                    </li>
                                    <li>
                                        <label htmlFor="dg-img-link-and">
                                            android link
                                        </label>
                                        <input
                                            type="text"
                                            id="dg-img-link-and"
                                            name="android"
                                            onChange={imgLinkList}
                                            value={
                                                UpdatedImglinkList.android
                                                    ? UpdatedImglinkList.android
                                                    : ''
                                            }
                                        />
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </>
                )}
            </form>
        </div>
    );
};

export default ModalSetImg;
